import React from 'react';
import styles from './CatchupAlert.module.css';

const CatchupAlert = ({ missedCount, missedDates, currentDate }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div className={styles.alert}>
      <div className={styles.icon}>!</div>
      <div className={styles.content}>
        <h3 className={styles.title}>
          CATCH-UP MODE: {missedCount} missed audit{missedCount > 1 ? 's' : ''}
        </h3>
        <p className={styles.description}>
          Complete sequentially: {missedDates && missedDates.length > 0 
            ? missedDates.map(formatDate).join(' → ')
            : `Starting from ${formatDate(currentDate)}`
          }
        </p>
      </div>
    </div>
  );
};

export default CatchupAlert;
